import { render, staticRenderFns } from "./CtcSiteConfigurationModal.vue?vue&type=template&id=33bfe0f5&scoped=true&"
import script from "./CtcSiteConfigurationModal.vue?vue&type=script&lang=js&"
export * from "./CtcSiteConfigurationModal.vue?vue&type=script&lang=js&"
import style0 from "./CtcSiteConfigurationModal.vue?vue&type=style&index=0&id=33bfe0f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bfe0f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardActions,VCardText,VSpacer})
